import { render } from "./deal-page.vue?vue&type=template&id=b89082a4&scoped=true"
import script from "./deal-page.vue?vue&type=script&lang=js"
export * from "./deal-page.vue?vue&type=script&lang=js"

import "./deal-page.vue?vue&type=style&index=0&id=b89082a4&lang=scss&scoped=true"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b89082a4"]])

export default __exports__